import $ from 'jquery';

class MegaMenu {
  constructor() {
    // Desktop nav wrapper
    this.navDesktop = document.querySelector('.nav--desktop');
    if (!this.navDesktop) {
      return;
    }

    // Read menu type from data attribute, default to megamenu
    this.menuType =
      this.navDesktop.getAttribute('data-menu-type') || 'megamenu';

    this.navItems = $(
      '.nav--desktop > .nav > .menu > .menu-item-has-children'
    );
    this.searchIcon = document.querySelector('.nav-search');
    this.search = $('#header-search');
    this.resizeTimer = null;

    // Init appropriate behaviour
    if (this.menuType === 'hamburger') {
      this.initHamburgerMenu();
    } else if (this.menuType === 'cascading') {
      this.initCascadingMenu();
    } else {
      this.initMegaMenu();
    }

    this.bindResize();
    this.initSearchToggle();
  }

  /* ======================
   * HAMBURGER MENU
   * ==================== */
  initHamburgerMenu() {
    const burger = this.navDesktop.querySelector('.nav__burger');
    const menu = document.querySelector('.hamburger-menu');

    if (!burger || !menu) return;

    // Prevent double-binding if this runs twice
    if (burger.dataset.megamenuBound === 'true') return;
    burger.dataset.megamenuBound = 'true';

    const body = document.body;

    const setState = (isOpen) => {
      menu.classList.toggle('is-active', isOpen);
      burger.classList.toggle('is-active', isOpen);
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      body.classList.toggle('has-hamburger-open', isOpen);
      body.style.overflow = isOpen ? 'hidden' : '';
    };

    // Toggle on burger click
    burger.addEventListener('click', (e) => {
      e.preventDefault();
      // IMPORTANT: stop bubbling so the document "click outside" handler
      // does NOT immediately close it again.
      e.stopPropagation();

      const isOpen = menu.classList.contains('is-active');
      setState(!isOpen);
    });

    // Close buttons inside menu (e.g. an X button)
    menu.querySelectorAll('[data-hamburger-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setState(false);
      });
    });

    // Close on ESC
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        setState(false);
      }
    });

    // Optional: click outside to close
    document.addEventListener('click', (e) => {
      // Only do anything if the menu is actually open
      if (!menu.classList.contains('is-active')) return;

      // Ignore clicks on the burger or inside the menu
      if (menu.contains(e.target) || burger.contains(e.target)) return;

      setState(false);
    });
  }

  /* ======================
   * MEGAMENU (hover)
   * ==================== */
  initMegaMenu() {
    if (!this.navItems.length) return;

    this.navItems.each(function () {
      const $item = $(this);

      $item.on('mouseenter.megamenu', function () {
        $item.addClass('is-open');
      });

      $item.on('mouseleave.megamenu', function () {
        $item.removeClass('is-open');
      });
    });
  }

  /* ======================
   * CASCADING MENU (click)
   * ==================== */
  initCascadingMenu() {
    if (!this.navItems.length) return;

    this.navItems.each(function () {
      const $item = $(this);
      const $toggle = $item.children('a').first();

      $toggle.on('click.cascading', function (e) {
        // Only intercept for top-level items
        const isTopLevel = $item.parent().hasClass('menu');
        if (!isTopLevel) return;

        e.preventDefault();
        $item.toggleClass('is-open');
      });
    });
  }

  /* ======================
   * SEARCH TOGGLE (optional)
   * ==================== */
  initSearchToggle() {
    if (!this.searchIcon || !this.search.length) return;

    this.searchIcon.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = this.search.hasClass('is-active');
      this.search.toggleClass('is-active', !isOpen);
      this.searchIcon.setAttribute('aria-expanded', (!isOpen).toString());

      if (!isOpen) {
        const input = this.search.find(
          'input[type="search"], input[type="text"]'
        )[0];
        if (input) {
          input.focus();
        }
      }
    });
  }

  /* ======================
   * RESIZE HANDLER (stub)
   * ==================== */
  bindResize() {
    window.addEventListener('resize', () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        // Hook if you need to recalc layout on resize
      }, 150);
    });
  }
}

/* =====================================
 * Initialise once DOM is ready, only once
 * =================================== */

let megaMenuInitialised = false;

const initMegaMenuOnce = () => {
  if (megaMenuInitialised) return;
  megaMenuInitialised = true;
  new MegaMenu();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenuOnce, {
    once: true,
  });
} else {
  initMegaMenuOnce();
}

export default MegaMenu;